var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MinusTriangle = function (_a) {
    var props = __rest(_a, []);
    return (_jsxs("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsxs("g", __assign({ clipPath: "url(#clip0_6640_99482)" }, { children: [_jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.47724 3.98792C10.0429 1.25923 13.9571 1.25924 15.5228 3.98792L23.449 17.8019C25.0146 20.5306 23.0575 23.9414 19.9262 23.9414H4.07379C0.942453 23.9414 -1.01463 20.5306 0.551041 17.8019L8.47724 3.98792ZM13.7614 5.01117C12.9785 3.64683 11.0215 3.64683 10.2386 5.01117L2.31242 18.8251C1.52958 20.1895 2.50813 21.8949 4.07379 21.8949H19.9262C21.4919 21.8949 22.4704 20.1895 21.6876 18.8251L13.7614 5.01117Z", fill: "currentColor" }), _jsx("line", { x1: "16", y1: "14.4121", x2: "8", y2: "14.4121", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })] })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_6640_99482" }, { children: _jsx("rect", { width: "24", height: "24", fill: "white", transform: "translate(24 24.9414) rotate(-180)" }) })) })] })));
};
